import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Table} from '../model/database/table';
import {Column} from '../model/database/column';
import {ProjectService} from '../project/project.service';
import {Database} from '../model/database/database';
import {GenericModalComponent} from '../modal/generic-modal.component';

@Component({
    selector: 'dbTableDefinition',
    template: `
        <div class="modal" [style.display]="!hide ? 'inline' : 'none'" style="margin : 20px;" tabindex="-1" role="dialog"  aria-hidden="true">
        <div class="modal-dialog modal-lg"  role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <img class="dbTableIcon" src="../../assets/images/DBTable.png">
                    <h5 class="modal-title">Table Definition</h5>
                    <button type="button" (click)="hideTableDefinitionModal()" class="btn btn-danger" data-dismiss="modal" aria-label="Close">
                        <span class="closeX" aria-hidden="true"><i class="fas fa-times"></i></span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" style="margin-top:20px; margin-left:20px;">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Table Name</span>
                                            </div>
                                            <input type="text" aria-label="Column name" class="form-control" [(ngModel)]="tableName">
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Column Name</span>
                                            </div>
                                            <input type="text" aria-label="Column name" class="form-control" [(ngModel)]="columnName">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Type</span>
                                            </div>
                                            <input type="text" aria-label="Column type" class="form-control" [(ngModel)]="columnType">
                                        </div>
                                    </td>
                                    <td><button data-toggle="tooltip" title="Add Column" (click)="addColumnToTable()"><span style="color:#0aa361"><i class="fas fa-plus-square"></i></span></button></td>
                                </tr>
                                <tr *ngFor="let col of this.table.columns">
                                    <td>{{col.name}}</td>
                                    <td>{{col.type}}</td>
                                    <td><button data-toggle="tooltip" title="Remove Column" (click)="remove(col.name)">Remove</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row" style="margin-top:20px;">
                        <button *ngIf="!this.editTableFlag" data-toggle="collapse" role="button" aria-expanded="false" (click)="saveTable()" type="button" class="btn btn-info createTableBtn">Create Table</button>
                        <button *ngIf="this.editTableFlag" data-toggle="collapse" role="button" aria-expanded="false" (click)="saveTable()" type="button" class="btn btn-info createTableBtn">Alter Table</button>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <generic-info-modal [hide]="_hideInfoModal" (OkClick)="onOk()"></generic-info-modal>`,
    styles:[`.dbTableIcon{width:30px;height:30px;}.table{width:90%;} .createTableBtn{margin-left: 85%;}


    .modal-header{
        background-color:dodgerblue;
        color:antiquewhite;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        height:61px;
    }
    .modal-content{
        border-top-right-radius: 18px;
        border-top-left-radius: 18px;
    }
    .closeX{color:azure;size:25px;}
    .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
    .btn-danger:hover{background-color: #FF2400;}
    .appWindow{height:25px;margin-right:140px;}
    .genericIcon{height:60px;}`]})
export class DbTableDefinitionComponent implements OnInit {

    @Input() database:Database;
    @Output()  databaseEvent: EventEmitter<any> = new EventEmitter();
    private table = new Table('');
    private hide =true;

    private _hideInfoModal = true;
    private tableName:string;
    private columnName:string;
    private columnType:string;

    // Variable used for edit table purpose only
    private editTableFlag = false;
    private origTableLastColIndex:number;

    @ViewChild (GenericModalComponent) private genericModal:GenericModalComponent;


    constructor(private _projectService:ProjectService) {

    }

    ngOnInit(): void {

    }


    hideTableDefinitionModal() {
        this.hide = !this.hide;
        // this.editTableFlag = false;
    }

    addColumnToTable() {
        if(this.table.columns!=null) {
            this.table.columns.push(new Column(this.columnName,this.columnType));
        } else {
            this.table.columns = [];
            this.table.columns.push(new Column(this.columnName,this.columnType));
        }
    }

    saveTable() {
        this.table.name = this.tableName;


        if(this.table.columns == null || this.table.columns.length === 0) {

            this.genericModal.defineModal('Make sure the table definition is not empty.','Table Definition',250);

            this._hideInfoModal = !this._hideInfoModal;

            return;

        }
        if(this.editTableFlag) {
            if(this.table.columns.length-1 < this.origTableLastColIndex) {
                this.hideTableDefinitionModal();
                this.emitDBEvent();
                return;
            }
            this.table.alterTable =true;
            const arr = this.table.columns.splice(0,this.origTableLastColIndex+1);
            /*for(const col  of arr ) {
                alert(col.name+' '+col.type);
            }
            for(const col  of this.table.columns ) {
                alert(col.name+' '+col.type);
            }*/

            const alteredTable = new Table('');
            alteredTable.name = this.table.name;
            alteredTable.alterTable = true;
            alteredTable.columns = this.table.columns.slice(0,this.table.columns.length);
            for(let c = 0;c<arr.length;c++) {
                this.table.columns.splice(c,0,arr[c]);
            }

            this._projectService.alterTable(alteredTable, this.database.pId, this.database.qId, this.database.tId, this.database.terminalType).subscribe((next: any) => {

                // console.log('HTTP Status: -> ' + next);
                // this.database.tables.push(this.table);
                // this.table = new Table();
                    this.genericModal.defineModal('Table has been updated successfully.','Table Definition',200);

                    this._hideInfoModal = !this._hideInfoModal;
            },
                err=> {
                    this.genericModal.defineModal('Some error occurred while updating table!.','Table Definition',300);

                    this._hideInfoModal = !this._hideInfoModal;
                });
            /*const c = this.table.columns[this.table.columns.length-1];
            alert(c.name+' '+c.type);*/
        } else {
            this._projectService.createTable(this.table, this.database.pId, this.database.qId, this.database.tId, this.database.terminalType).subscribe((next: any) => {

                console.log('HTTP Status: -> ' + next);
                this.genericModal.defineModal('Table has been created successfully.','Table Definition',200);

                this._hideInfoModal = !this._hideInfoModal;
                // this.database.tables.push(this.table);
                this.table = new Table('');
            });
        }

        this.emitDBEvent();
        this.hideTableDefinitionModal();

    }

    remove(colName:string) {
        this.origTableLastColIndex = this.table.columns.length-1;
        const index = this.table.getColumnIndex(colName);

        this._projectService.dropColumn(this.table.name,colName,this.database.pId, this.database.qId, this.database.tId, this.database.terminalType).subscribe((next:any)=> {
            this.table.columns.splice(index,1);
            this.genericModal.defineModal('Column has been removed successfully.','Table Definition',200);

            this._hideInfoModal = !this._hideInfoModal;
        });
    }

    onOk() {
        this._hideInfoModal = !this._hideInfoModal;
    }

    edit(tableName:string):void {
        this.editTableFlag = true;
        let indx = 0;

        for(const table of this.database.tables) {
            if(table.name === tableName) {
                this.tableName =  tableName;
                break;
            }
            indx++;
        }

        this.table = this.database.tables[indx];// splice(indx,1)[0];
        this.origTableLastColIndex =this.table.columns.length-1;

        this.hideTableDefinitionModal();
    }

    private emitDBEvent():void {
        let idx = 0;
        for(const tab of this.database.tables) {
            if(tab.name === this.table.name) {
                break;
            }
            idx++;
        }
        this.database.tables.splice(idx,1);
        this.database.tables.splice(idx,0,this.table);
        this.databaseEvent.emit(this.database);
    }


}
